<template>
            <!-- Footer -->
          <footer id="mainFooter" class="bg-sa-footer text-white py-2 footer-sticky">
  <div class="container-fluid">

    <div class="d-flex flex-column flex-md-row 
                justify-content-between 
                align-items-center 
                text-center text-md-start
                gap-1">

      <div>
        SmartAdmin 1.9.0 - Web Application Framework © 2017-2019
      </div>

      <div class="text-md-end">
        Last account activity
        <i class="fa fa-clock-o ms-1"></i>
        52 mins ago
      </div>

    </div>

  </div>
</footer>

            <!-- Fix/unfix footer button (optional) -->	
</template>